import styled from 'styled-components';

export const Container = styled.div`
  .validation-buttons-wrapper {
    width: 100%;
    padding: 16px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  width: 100%;
  .left-icon {
    width: 14px;
    margin-right: 17px;
    color: #323e48;
  }
  .right-icon {
    width: 14px;
    margin-left: 17px;
    fill: #fff;
  }
  .add-recap-bloc-title {
    color: #2b2727;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 24px;
  }
`;
